<p-dialog
  [(visible)]="visible"
  [header]="supportTktStatic.dialogHeader | translate"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  [dismissableMask]="true"
  [style]="{ width: '400px' }"
  (onHide)="onClose()"
  styleClass="support-ticket-dialog"
>
  <form [formGroup]="formGroup" class="support-tkt-form">
    <div *ngFor="let field of formData.fields">
      <label *ngIf="field.label" class="label"
        >{{ field.label | translate }}
        <span class="text-[#d34243]" *ngIf="field.isRequired">*</span></label
      >

      <input
        *ngIf="field.type === 'text'"
        class="form-control mb-2"
        type="text"
        [placeholder]="field.placeholder | translate"
        [formControlName]="field.name"
      />
      <textarea
        *ngIf="field.type === 'textarea'"
        rows="4"
        class="text-area-field"
        type="textarea"
        [placeholder]="field.placeholder | translate"
        [formControlName]="field.name"
      >
      </textarea>

      <div
        *ngIf="field.type === 'btn-select'"
        class="flex justify-start gap-2 mb-2"
      >
        <p-chip
          (click)="onSelectImpactLevel('high')"
          styleClass="impact-level-chip {{
            impactLevel.high ? 'high-active' : ''
          }}"
        >
          <app-svg-icon
            icon="high-impact"
            color="{{ impactLevel.high ? '#D14447' : '#666666' }}"
            padding="8px"
          >
          </app-svg-icon>
          <span class="p-chip-text">{{
            "SUPPORT_TICKET.HIGH" | translate
          }}</span>
        </p-chip>
        <p-chip
          (click)="onSelectImpactLevel('medium')"
          styleClass="impact-level-chip {{
            impactLevel.medium ? 'medium-active' : ''
          }}"
          label="{{ 'SUPPORT_TICKET.MEDIUM' | translate }}"
        >
          <app-svg-icon
            icon="medium-impact"
            color="{{ impactLevel.medium ? '#FF6348' : '#666666' }}"
            padding="8px"
          >
          </app-svg-icon
        ></p-chip>
        <p-chip
          (click)="onSelectImpactLevel('low')"
          styleClass="impact-level-chip {{
            impactLevel.low ? 'low-active' : ''
          }}"
          label="{{ 'SUPPORT_TICKET.LOW' | translate }}"
        >
          <app-svg-icon
            icon="low-impact"
            color="{{ impactLevel.low ? '#6EBC14' : '#666666' }}"
            padding="8px"
          >
          </app-svg-icon
        ></p-chip>
      </div>

      <app-upload-file
        styleClassName="support-ticket"
        *ngIf="
          field.type === 'file-upload' && !fileUploadContent.fileUploadStatus
        "
        [isMultiple]="true"
        [uploadDataContent]="supportTktStatic.fileUploadContent"
        (actionBrowseButtonCall)="onFileBrowse($event)"
        (actionFileDropCall)="onFileDrop($event)"
      ></app-upload-file>

      <div
        *ngIf="
          field.type === 'file-upload' && fileUploadContent.fileUploadStatus
        "
        class="uploaded-files-preview text-center border border-[#e5e5e5] rounded p-4"
      >
        <img width="43px" src="/assets/images/icon-file-upload-completed.svg" />
        <div class="pt-3 text-sm flex justify-center gap-2 items-center">
          <p>{{ fileUploadContent.fileList.length }} files selected</p>
          <i
            class="pi pi-times-circle cursor-pointer"
            (click)="clearFileSelection()"
          ></i>
        </div>
      </div>

      <div
        *ngIf="
          field.type === 'file-upload' &&
          !fileUploadContent.fileUploadStatus &&
          fileUploadContent.fileUploadError
        "
        class="text-red-500 text-xs mt-0.5"
      >
        {{ fileUploadContent.fileUploadError }}
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="mb-3 text-left" *ngIf="is_beta_user">
      <a href="https://insights-copilot.staging.ab-inbev.com/" target="_blank" class="text-xs text-blue-500 underline">Talk to our AI assistant</a>
    </div>
    <div class="flex justify-end gap-3">
      <app-button-secondary
        buttonClassName="medium"
        (actionButtonCall)="closeDialog()"
        [buttonCaption]="'SUPPORT_TICKET.CANCEL' | translate"
      ></app-button-secondary>
      <app-button-primary
        [buttonCaption]="'SUPPORT_TICKET.SUBMIT' | translate"
        buttonClassName="medium"
        [buttonDisabled]="!formGroup.valid"
        [loaderEnabledFlag]="showDialogLoader"
        (actionButtonCall)="onFormSubmit()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
